import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./MembersVideoGrid.scss";
import { selectIcon, SVG } from "../../../../components/UI/selector";
import {
  CheckValue,
  getAvailableUser,
} from "../../../../services/CommonFunction";
import { checkLimit } from "../ChildComponentUI";
import Pagination from "../../Pagination/Pagination";

const limit = 10;

const MembersVideoGrid = (props) => {
  const { allUsers, zoom, userPin, isHangout } = props;

  const videoBoardRef = useRef(null);

  const [page, setPage] = useState(1);
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [canvasHeight, setCanvasHeight] = useState(0);

  const { allUsersArr, allUserLength } = getAvailableUser(
    allUsers,
    "not_ended"
  );
  const users = checkLimit(allUsersArr, limit, page - 1, zoom);
  // console.log("users", users);

  useEffect(() => {
    if (!users.length && page > 1) {
      setPage((prevState) => prevState - 1);
    }
  }, [users.length]);

  // useEffect(() => {
  //   const temp = checkLimit(allUsers, limit, page - 1, zoom);
  //   setUsers(temp.map((el) => el.user_id));
  // }, [allUsers, limit, page, CheckValue(zoom)]);

  useLayoutEffect(() => {
    const width = videoBoardRef.current.getBoundingClientRect().width;
    var height = 0;
    var userHeight = 149;
    var minUsers = 2;
    if (isHangout) {
      minUsers = 3;
      userHeight = 281;
    }
    const rows = Math.ceil(limit / minUsers);
    // const rows =
    //   allUserLength > limit
    //     ? Math.ceil(limit / minUsers)
    //     : Math.ceil(allUserLength / minUsers);
    height = rows * userHeight;
    console.log(allUserLength, rows, height);
    setCanvasWidth(width);
    setCanvasHeight(height);
  }, [allUserLength]);

  const paginationCallback = useCallback(
    (newPage) => {
      if (page !== newPage) {
        zoom.stopVideosAndClearCanvas();
      }
      setPage(newPage);
    },
    [page, setPage, zoom]
  );

  const canvasUI = useMemo(
    () => (
      <canvas
        id={"participants-canvas"}
        className="video-canvas"
        width={canvasWidth}
        height={canvasHeight}
      ></canvas>
    ),
    [canvasWidth, canvasHeight]
  );
  const pagination = useMemo(
    () => (
      <Pagination
        limit={limit}
        currentPage={page}
        setPage={paginationCallback}
        userArrLength={allUserLength}
      />
    ),
    [limit, page, allUserLength]
  );
  if (!allUsers) {
    return;
  }

  return (
    <Fragment>
      <div
        className={!isHangout ? "memberBoard" : "memberBoardHangout"}
        id={"memberVideoBoard"}
        ref={videoBoardRef}
      >
        {canvasUI}
        {users.map((el) => {
          return !isHangout ? (
            <MemberVideo
              key={el.user_id}
              user={el}
              userPin={userPin}
              isPinned={el.showStream}
            />
          ) : (
            <MemberVideoHangout key={el.user_id} user={el} />
          );
        })}
      </div>
      {pagination}
    </Fragment>
  );
};

export default MembersVideoGrid;

function MemberVideo({ user, isPinned = false, userPin }) {
  return (
    <div className={"MemberVideo box-layer2 " + (user.me ? "me" : "")}>
      <div className={"video-area"} id={user.user_id}>
        <img
          className={"center-profile-pic"}
          src={user.profile_pic_thumb}
          height={60}
          width={60}
        />
        {!user.me ? (
          <div
            className={"pin-icon"}
            onClick={() => {
              userPin(user.user_id);
            }}
          >
            <SVG
              src={selectIcon("pinIcon")}
              height={10}
              width={10}
              fill={isPinned ? "var(--color-primary)" : "#767676"}
            />
          </div>
        ) : null}
        <span className={"user-name"}>{user.me ? "Me" : user.first_name}</span>
      </div>
    </div>
  );
}

function MemberVideoHangout({ user }) {
  return (
    <div className={"MemberVideoHangout " + (user.me ? "me" : "")}>
      <div className={"video-area"} id={user.user_id}>
        {!user.stream ? (
          <img
            className={"full-profile-pic"}
            src={user.profile_pic_thumb}
            width={150}
          />
        ) : null}
        <div className={"footer"}>{user.me ? "Me" : user.first_name}</div>
      </div>
    </div>
  );
}
